module.exports = __webpack_public_path__ + "static/img/qnstatus4.00db58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus4.png
// module id = 366
// module chunks = 0